import { FC } from 'react';
import { IonToolbar } from '@ionic/react';
import { AllieToolbarProps } from './Toolbar.types';

export const AllieToolbar: FC<AllieToolbarProps> = (props) => (<IonToolbar {...props} />);
